var React = require('react');

function StatusSuccess (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M16 3.273c7.03 0 12.727 5.698 12.727 12.727 0 7.03-5.698 12.727-12.727 12.727C8.97 28.727 3.273 23.03 3.273 16 3.273 8.97 8.97 3.273 16 3.273zm5.001 7.327l-6.935 8.877-3.858-3.087-.908 1.136 5.007 4.006 7.84-10.036-1.146-.896z"})));
}

StatusSuccess.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = StatusSuccess;

StatusSuccess.default = StatusSuccess;
